import { getUser } from "../services/Auth";
import api from "./api";

export const CadastrarHorarioFuncionamento = async (data) => {
  try {
    const usuario = await getUser();
    const res = await api.post(
      `/estabelecimentos/${usuario.estabelecimento._id}/horarios-funcionamento`,
      data,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const EditarHorarioFuncionamento = async (idHorario, data) => {
  try {
    const usuario = await getUser();
    const res = await api.put(
      `/estabelecimentos/${usuario.estabelecimento._id}/horarios-funcionamento/${idHorario}`,
      data,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const DeletarHorarioFuncionamento = async (idHorario) => {
  try {
    const usuario = await getUser();
    const res = await api.delete(
      `/estabelecimentos/${usuario.estabelecimento._id}/horarios-funcionamento/${idHorario}`,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
